const url = "/seguranca";

export function pesquisarAll() {
  return new Promise((resolve, reject) => {
    window.$http.get(`${url}`).then((res) => {
      resolve(res.data);
    });
  });
}

export function salvarPerfil(registro) {

  if (registro.id && registro.id != 0) {
    criar(registro)
  } else {
    atualizar(registro)
  }

}

function criar(registro) {
  return new Promise((resolve, reject) => {
    window.$http.post(`${url}/perfilacessos`, JSON.stringify(registro)).then((res) => {
      resolve(res.data);
    });
  });
}

function atualizar(registro) {
  return new Promise((resolve, reject) => {
    window.$http.put(`${url}/perfilacessos/${registro.id}`, JSON.stringify(registro)).then((res) => {
      resolve(res.data);
    });
  });
}